define('extant/extant',['require','exports','module'],function(require,exports,module) {
   var UNDEF   = "undefined",
        STRING  = "string",
        COMMA   = ",",
        DOT     = ".";

    /**
     * Confirm an object path exists
     * @param  {object}     obj       object to test agains
     * @param  {string}     path      Dot delimited path
     * @param  {boolean}    falseNull Should false be considered null
     * @return {boolean}              True if full path exist
     */
    function checkDeep(obj, path, falseNull){
        var vals = path.indexOf(DOT) != -1 ? path.split(DOT) : [path],
            i = 0,
            val = obj,
            len = vals.length;

        for (; i < len; i++) {
            val = val[vals[i]];
            if(nullOrUndef(val,falseNull)){
                return false
            }
        }
        return true;
    }

    /**
     * Confirm a set of properties exist on an object
     * @param  {object}     obj        object to test agains
     * @param  {string}     props      Comma delimited set of properties
     * @param  {boolean}    falseNull  Should false be considered null
     * @return {boolean}               True if all properties exist 
     */
    function checkSet(obj,props,falseNull) {
        var vals = (typeof props === STRING) ? (props.indexOf(COMMA) != -1 ? props.split(COMMA) : [props]): [].concat(props),
            i = 0,
            len = vals.length;

        for (; i < len; i++) {
            if(!checkDeep(obj,vals[i],falseNull)){
                return false
            }
        }
        return true;
    }
    /**
     * Check if a object is undefined or null
     * @param  {mixed}  thing     Object to test
     * @param  {boolean}falseNull Should false be considered null
     * @return {boolean}          True if false or null
     */
    function nullOrUndef(thing,falseNull){
        return (typeof thing === UNDEF  || thing === null || (falseNull && thing === false));
    }

    return function(prop, path, falseNull) {
        falseNull = falseNull===true;

        if(nullOrUndef(prop,falseNull)){
            return false
        }

        if (typeof path !== UNDEF){
                return checkSet(prop, path, falseNull); 
        }
        return true;
    }
});
